// extracted by mini-css-extract-plugin
export var content = "clients-module--content--nsIFj";
export var curvedCarousel = "clients-module--curvedCarousel--0KlJU";
export var h2 = "clients-module--h2--VBo+O";
export var icon = "clients-module--icon--zWygL";
export var info = "clients-module--info--PNiyQ";
export var logo = "clients-module--logo--YMRui";
export var logoItem = "clients-module--logoItem--A8wZI";
export var logos = "clients-module--logos--G2UVr";
export var sectionClients = "clients-module--sectionClients---0piq";